import styles from 'styles/modules/SidescreenEditCompanyInfo.module.scss';
import inputStyle from 'styles/modules/Input.module.scss';
import { useState } from 'react';
import Enter from 'components/Svg/Enter';
import Remove from 'components/Svg/Remove';

import { formatUrl, getSocialIcon, isSocial, isUrl } from 'helpers/url';

import { profile } from 'lang/en.json';
import Tick from 'components/Tick';
import Typo from 'components/Typo';

const Social = ({ callback, socialNetwork }) => {
    const [hasError, setHasError] = useState(false);
    const [enabledButton, setEnabledButton] = useState(false);
    const [newLink, setNewLink] = useState(null);

    const [val, setVal] = useState('');

    const socialTypes = [
        'facebook',
        'instagram',
        'linkedin',
        'twitter',
        'youtube',
        'tiktok',
        'mastodon',
        'threads',
        'x',
    ];

    const hasSocialType = (type) => {
        const filtered = socialNetwork.filter((item) => {
            return item.name === type;
        });

        return filtered.length > 0;
    };

    const handleKeyDown = (e) => {
        const key = e.key?.toLowerCase();
        if (key === 'enter') {
            e.preventDefault();
            const val = e.target.value;
            const social = isSocial(val, socialTypes);

            if (!isUrl(val) || !social || hasSocialType(social)) {
                setHasError(true);
                return null;
            }
            handleSubmit(e);
        }
    };

    const handleKeyUp = (name, e) => {
        const { value } = e.target;
        const key = e.key?.toLowerCase();
        setVal(value);

        if (key === 'enter') return null;

        if (value && value.trim() !== '') {
            const social = isSocial(value, socialTypes);

            if (!isUrl(value) || !social || hasSocialType(social)) {
                setHasError(true);
                setNewLink(null);
                return null;
            }
            const formattedValue = formatUrl(value);

            setEnabledButton(true);
            setNewLink({
                name: social,
                url: formattedValue,
            });
            setHasError(false);
        } else {
            setNewLink(null);
            setEnabledButton(false);
            setHasError(false);
        }
    };

    const handleChange = (e) => {
        const val = e.target.value;
        setVal(val);

        const social = isSocial(val, socialTypes);

        if (!isUrl(val) || !social || hasSocialType(social)) {
            setHasError(true);
            return null;
        }
        const value = formatUrl(val);

        setEnabledButton(true);
        setNewLink({
            name: social,
            url: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        callback([...socialNetwork, newLink]);
        setVal('');
        setNewLink(null);
        setEnabledButton(false);
    };

    const handleRemove = (name) => {
        const tmp = socialNetwork.filter((item) => item.name !== name);
        callback([...tmp]);
    };
    const linksItems = socialNetwork.map((item, key) => {
        if (!item.url) return null;

        let icon = getSocialIcon(item.name);

        return (
            <div key={`link-${key}`} className={styles.socialItem}>
                {icon}
                <span>{item.url}</span>
                <span
                    className={styles.remove}
                    onClick={() => handleRemove(item.name)}
                >
                    <Remove />
                </span>
            </div>
        );
    });

    return (
        <div className={styles.social}>
            <Typo variant={'body'} className={'mb-xxs'}>
                {profile.header.details.sidebar.social_links}
            </Typo>

            <div className={styles.socialNetwork}>{linksItems}</div>

            {socialTypes.length > socialNetwork.length && (
                <div className={styles.inputWrapper}>
                    <div
                        className={[
                            inputStyle.inputWrapper,
                            hasError ? inputStyle.inputWrapperError : null,
                        ].join(' ')}
                    >
                        <div className={styles.liveSocial}>
                            {getSocialIcon(newLink?.name)}
                        </div>
                        <div
                            className={[
                                styles.enter,
                                newLink ? styles.enterActive : '',
                            ].join(' ')}
                        >
                            <Enter />
                        </div>
                        <input
                            id={'socialLink'}
                            name={'socialLink'}
                            type="text"
                            className={inputStyle.input}
                            value={val}
                            placeholder={
                                profile.header.details.sidebar
                                    .social_link_placeholder
                            }
                            onKeyDown={handleKeyDown}
                            onChange={handleChange}
                            onKeyUp={(e) => {
                                handleKeyUp('socialLink', e);
                            }}
                        />
                    </div>

                    <Tick
                        onClick={handleSubmit}
                        disabled={!enabledButton}
                        className={styles.tick}
                    />
                </div>
            )}
        </div>
    );
};

export default Social;
